import service from '../service'
import wx from 'weixin-js-sdk'
const defer = {
  promise: null,
  resolve: null,
  reject: null
}
defer.promise = new Promise((resolve, reject) => {
  defer.resolve = resolve
  defer.reject = reject
})

wx.ready(function () {
  // console.log('weixin:jssdk 初始化成功')
  defer.resolve()
})
wx.error(function (res) {
  // console.log('weixin:jssdk 初始化失败 ' + JSON.stringify(res))
})

export default {
  wx,
  init () {
    // console.log('init 函数中')
    service.getJssdkInfo().then(this.wxConfig)
  },
  wxConfig (info) {
    info = info.data
    // console.log('getJssdkInfo=' + JSON.stringify(info))
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: info.appid, // 'wx0a5782e7943eb1e3', // 必填，公众号的唯一标识
      timestamp: info.timestamp, // '1575354865', // 必填，生成签名的时间戳
      nonceStr: info.nonceStr, // 'xbx5o4y828o', // 必填，生成签名的随机串
      signature: info.signature, // 'b328a9be0e59244c4d54213b950489fad08d6a6a', // 必填，签名，见附录1
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone'
      ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      openTagList: ['wx-open-launch-weapp']
    })
  },
  ready () {
    return defer.promise
  },
  setShareData (data) {
    return this.ready().then(() => {
      // console.log('setShareData ready 准备调起分享方法', data)
      // 这几个接口微信文档中表示准备废弃
      // 但是新的接口拿不到用户的分享状态
      // 所以还是用这几个接口
      wx.onMenuShareTimeline(data)
      wx.onMenuShareAppMessage(data)
      wx.onMenuShareQQ(data)
      wx.onMenuShareWeibo(data)
      wx.onMenuShareQZone(data)
      wx.updateAppMessageShareData(data)
      wx.updateTimelineShareData(data)
    })
  }
}
